<label *ngIf="label" class="data-label" [ngClass]="labelClass">{{ label }}</label>
<input class="form-control datepicker-input" [formControl]="control" ngbDatepicker [minDate]="minDate"
  [maxDate]="maxDate" #d="ngbDatepicker" (click)="toggle(d)" [value]="getFormattedDate(control.value)"
  [placeholder]="placeholder" autocomplete="off">
<img src="./assets/images/ic-arrow-down-dark.svg" alt="Icon" class="arrow">